<template>
  <BackgroundImageComponent></BackgroundImageComponent>
  <div class="container mt-4 position-relative">
    <div class="card mb-4">
      <div class="card-body">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-center"
        >
          <h1 class="text-ruderclub-orange">Einstellungen</h1>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="saveEinstellungen">
              <div class="mb-3">
                <h5>Benutzer</h5>
                <label for="name" class="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  class="form-control"
                  v-model="benutzer.name"
                  required
                />
              </div>

              <hr />

              <h5>Countdown</h5>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="countdownSound"
                  v-model="benutzer.countdownSound"
                />
                <label
                  class="form-label form-check-label"
                  for="countdownSound"
                  >{{
                    benutzer.countdownSound
                      ? "Sound wird abgespielt"
                      : "Sound wird nicht abgespielt"
                  }}</label
                >
              </div>
              <div>
                <label for="countdownSekunden" class="form-label"
                  >Dauer (Sekunden)</label
                >
                <input
                  type="number"
                  step="1"
                  min="0"
                  id="countdownSekunden"
                  class="form-control"
                  v-model.number="benutzer.countdownSekunden"
                  required
                />
              </div>

              <hr />
              <h5>Training</h5>
              <div class="mb-3">
                <label for="defaultTrainingsname" class="form-label"
                  >Standard Name</label
                >
                <input
                  type="text"
                  id="defaultTrainingsname"
                  class="form-control"
                  v-model="benutzer.defaultTrainingsname"
                  required
                />
              </div>

              <div class="mb-3">
                <label class="form-label">Standard Trainingsmethode</label>
                <div class="d-flex flex-column flex-md-row gap-3">
                  <button
                    type="button"
                    class="d-flex align-items-center btn rounded-pill text-dark"
                    :class="
                      benutzer.defaultTrainingsmethodeFilter === 'rudern'
                        ? 'bg-info border border-dark'
                        : 'border border-info'
                    "
                    @click="toggleTrainingsmethode('rudern')"
                  >
                    <TrainingsmethodeIconComponent
                      trainingsmethode-id="rudern"
                      :class="
                        benutzer.defaultTrainingsmethodeFilter === 'rudern'
                          ? 'text-dark'
                          : 'text-info'
                      "
                      class="me-2"
                    ></TrainingsmethodeIconComponent>
                    Rudern
                  </button>

                  <button
                    type="button"
                    class="d-flex align-items-center btn rounded-pill text-dark"
                    :class="
                      benutzer.defaultTrainingsmethodeFilter === 'fahrradfahren'
                        ? 'bg-success border border-dark'
                        : 'border border-success'
                    "
                    @click="toggleTrainingsmethode('fahrradfahren')"
                  >
                    <TrainingsmethodeIconComponent
                      trainingsmethode-id="fahrradfahren"
                      :class="
                        benutzer.defaultTrainingsmethodeFilter ===
                        'fahrradfahren'
                          ? 'text-dark'
                          : 'text-success'
                      "
                      class="me-2"
                    ></TrainingsmethodeIconComponent>
                    Fahrradfahren
                  </button>

                  <button
                    type="button"
                    class="d-flex align-items-center btn rounded-pill text-dark"
                    :class="
                      benutzer.defaultTrainingsmethodeFilter === 'laufen'
                        ? 'bg-warning border border-dark'
                        : 'border border-warning'
                    "
                    @click="toggleTrainingsmethode('laufen')"
                  >
                    <TrainingsmethodeIconComponent
                      trainingsmethode-id="laufen"
                      :class="
                        benutzer.defaultTrainingsmethodeFilter === 'laufen'
                          ? 'text-dark'
                          : 'text-warning'
                      "
                      class="me-2"
                    ></TrainingsmethodeIconComponent>
                    Laufen
                  </button>
                </div>
              </div>

              <hr />

              <div class="d-flex justify-content-end">
                <button
                  type="submit"
                  class="btn btn-ruderclub-dark-green d-flex align-items-center"
                >
                  <i class="material-symbols-outlined me-2">save</i>Speichern
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { firebaseAuth, firebaseDb } from "@/main";
import BackgroundImageComponent from "@/components/Shared/BackgroundImageComponent.vue";
import { notify } from "@kyvg/vue3-notification";
import TrainingsmethodeIconComponent from "@/components/Shared/TrainingsmethodeIconComponent.vue";

export default {
  components: { BackgroundImageComponent, TrainingsmethodeIconComponent },
  data() {
    return {
      benutzer: {
        name: "",
        countdownSekunden: 0,
        countdownSound: true,
        defaultTrainingsname: "",
        defaultTrainingsmethodeFilter: "",
      },
    };
  },
  async mounted() {
    const userDocRef = doc(
      firebaseDb,
      "benutzer",
      firebaseAuth.currentUser.uid
    );
    const userDocSnap = await getDoc(userDocRef);

    if (userDocSnap.exists()) {
      this.benutzer = userDocSnap.data();
    } else {
      console.log("Nutzer konnte nicht geladen werden.");
    }
  },
  methods: {
    async saveEinstellungen() {
      try {
        await updateDoc(
          doc(firebaseDb, "benutzer", firebaseAuth.currentUser.uid),
          this.benutzer
        );
        notify({
          title: "Erfolg",
          text: "Einstellungen gespeichert.",
          type: "success",
          duration: 5000,
        });
      } catch (error) {
        console.log("Speichern nicht möglich: ", error);
        notify({
          title: "Fehler",
          text: "Einstellungen konnten nicht gespeichert werden.",
          type: "error",
          duration: 5000,
        });
      }
    },
    toggleTrainingsmethode(methode) {
      if (this.benutzer.defaultTrainingsmethodeFilter === methode) {
        this.benutzer.defaultTrainingsmethodeFilter = "";
      } else {
        this.benutzer.defaultTrainingsmethodeFilter = methode;
      }
    },
  },
};
</script>

<style scoped>
.form-label {
  font-weight: bold;
}

hr {
  opacity: 1 !important;
  height: 2px;
  background-color: var(--ruderclub-dark-green); /* Farbe anpassen */
  border: none; /* Standardrahmen entfernen */
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>
